import React from 'react'
import { Button, Modal } from '@tecsinapse/cortex-react'
import { IoMdClose } from 'react-icons/io'
import { Trans } from '@lingui/react/macro'
import { useModalOverflowHidden } from '@/core/hooks/use-modal-overflow-hidden'
import {
  GrupoUsuariosEdicao,
  GrupoUsuariosEdicaoProps
} from '@/modules/grupo-usuarios-edicao/ui/grupo-usuarios-edicao'

interface GrupoUsuariosEdicaoDialogProps
  extends Omit<GrupoUsuariosEdicaoProps, 'isModal'> {
  open: boolean
  onClose: () => void
  onOpen?: () => void
}

export const GrupoUsuariosEdicaoDialog = ({
  handleCloseDialog,
  open,
  onClose,
  onOpen
}: GrupoUsuariosEdicaoDialogProps) => {
  useModalOverflowHidden({ open })

  return (
    <Modal
      open={open}
      onClose={onClose}
      className='flex flex-col w-[72rem] max-w-[92vw] overflow-y-auto max-h-[85vh]'
    >
      <div className={'flex flex-row justify-between items-center mb-deca'}>
        <p className={'font-bold text-h3 text-center w-full'}>
          <Trans>Novo Grupo de Usuários</Trans>
        </p>
        <Button variants={{ size: 'square' }} onClick={onClose}>
          <IoMdClose />
        </Button>
      </div>
      <GrupoUsuariosEdicao
        handleCloseDialog={handleCloseDialog}
        onClose={onClose}
        onOpen={onOpen ?? (() => {})}
        isModal
      />
    </Modal>
  )
}
